/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
(function () {
  'use strict';
  app.NewsRouter = app.Router.extend({
    mode: 'server',
    
    handleRoute: function (page) {
      var params = app.helpers.UrlHelper.getUrlParameters(),
        that = this,
        defaults = {
          'category': this.collection.defaults.category
        };
      // Валидируем полученные из урла параметры
      _.each(params, function (param, key) {
        return _.indexOf(that.allowed, key) >= 0 ? params[key] = param : params[key] = defaults[key];
      });
      _.defaults(params, defaults);
      
      page = parseInt(page, 10);
      if (!page) {
        page = 1;
      }
      if (this.collection.categoryFilter !== params.category) {
        this.collection.setCategoryFilter(params.category);
        this.trigger('change-category-filter');
      }
      if (this.collection.state.currentPage !== page) {
        this.trigger('change-page');
      }
      try {
        this.collection.getPage(page);
      } catch (e) {
        var message = e.message;
        e.message = 'We know, that something went bad with that paginator thing. Here is the original message: ' + message;
        if (typeof Raven !== 'undefined' && typeof Raven.captureException === 'function') {
          Raven.captureException(e);
        } else {
          throw e;
        }
      }
    }
  });
}());

}.call(window));